import { FC, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { gatherMethods, isArray } from '@lhb/func';
import { CITY_LEVEL } from '@/common/components/AMap/ts-config';
import { CollectListContext } from '../../../ts-config';
import cs from 'classnames';
import styles from './index.module.less';
import { Spin } from 'antd';
import Row from './Row';
import Sort from './Sort';
import List from './List';
import Tool from './Tool';
import V2Empty from '@/common/components/Data/V2Empty';
import Footer from './List/Footer';

/**
 * @Description 右侧列表
 */
const RightCon:FC<{
  mapIns,
  level,
  locationInfo,
  searchParams,
  itemData, // 选中的商圈项
  poiData, // 地址搜索
  listData, // 列表数据
  setItemData,
  rankSort,
  setRankSort,
  isLoading, // 右侧是否加载中
  setOpenList, // 设置右边展开
  openList, // 右侧是否展开
  districtCluster, // 点击区时
  setDistrictCluster,
  hasOtherData, // 是否存在生成中的数据
  isBatchCollect,
  setIsBatchCollect,
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds, // 设置批量收藏的开店区域ids
  handleQuitBatch, // 退出批量操作
  cityProvinceInfo, // 城市省市区信息
  showLeftCon,
}> = ({
  mapIns,
  level,
  locationInfo,
  searchParams,
  itemData, // 选中的商圈项
  poiData, // 地址搜索
  listData, // 列表数据
  setItemData,
  rankSort,
  setRankSort,
  isLoading, // 右侧是否加载中
  setOpenList, // 设置右边展开
  openList, // 右侧是否展开
  districtCluster, // 点击区时
  setDistrictCluster,
  hasOtherData, // 是否存在生成中的数据
  isBatchCollect,
  setIsBatchCollect,
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds, // 设置批量收藏的开店区域ids
  handleQuitBatch, // 退出批量操作
  cityProvinceInfo, // 城市省市区信息
  showLeftCon,
}) => {

  const { collectList }: any = useContext(CollectListContext);

  const [distanceSort, setDistanceSort] = useState<boolean>(false);

  const [showBack, setShowBack] = useState(false); // 是否显示返回顶部
  const lastIndexRef: any = useRef(0); // 记录列表关闭前的索引
  const listRef: any = useRef();
  const [realListData, setRealListData] = useState<any[]>([]); // 同步虚拟列表的数据(和listData数据其实是一样的，只不过虚拟列表里额外往里插了一些字段)

  // listData变化时，清空itemData
  useEffect(() => {
    const { isFirst } = itemData;
    if (isFirst) return;
    setItemData({
      visible: false, // 是否显示详情
      id: null,
      detail: null, // 存放详情相关字段
      isFirst: false
    });
    lastIndexRef.current = 0;
    // 如果没有数据时而且处于批量收藏状态时
    if (listData.length === 0) {
      isBatchCollect && handleQuitBatch && handleQuitBatch();
    }
  }, [listData]);
  // 左侧筛选引起的右侧列表数据变化时，如果此时在批量收藏状态时，取两次数据且选中的交集
  useEffect(() => {
    if (!(isBatchCollect && batchCollectIds.length && realListData.length)) return;
    const realListDataIds = realListData.map((item: any) => item.id);
    // 取交集
    const commonBatchCollectIds = gatherMethods(realListDataIds, batchCollectIds, 1);
    setBatchCollectIds(isArray(commonBatchCollectIds) ? commonBatchCollectIds : []);
  }, [realListData]);
  // 是否显示底部组件
  const showFooterCom = useMemo(() => {
    return showBack || isBatchCollect;
  }, [showBack, isBatchCollect]);
  const targetCity = useMemo(() => {
    return level >= CITY_LEVEL;
  }, [cityProvinceInfo, level]);

  const backTop = () => {
    listRef.current && listRef.current.scrollToItem(0, 'start');
  };


  useEffect(() => {
    if (itemData?.id) setOpenList(true);
  }, [itemData?.id]);

  return <>
    {
      targetCity ? <div className={styles.wrapperCon}>
        {/* 推荐个数行 */}
        <Row
          total={listData?.length || 0}
          openList={openList}
          districtCluster={districtCluster}
          setOpenList={setOpenList}
          setDistrictCluster={setDistrictCluster}
          cityProvinceInfo={cityProvinceInfo}
        />
        <div className={cs(styles.listCon, openList ? '' : styles.isFold)}
          style={{
            top: 61,
            height: openList ? ('calc(100vh - 129px)') : 0,
          }}
        >
          <Sort
            searchParams={searchParams}
            poiData={poiData}
            setRankSort={setRankSort}
            setDistanceSort={setDistanceSort}
            hasOtherData={hasOtherData}
            rankSort={rankSort}
            isBatchCollect={isBatchCollect}
            setIsBatchCollect={setIsBatchCollect}
          />

          <List
            // 加key保证两种情况下，会后重新渲染
            mapIns={mapIns}
            lastIndexRef={lastIndexRef}
            listRef={listRef}
            openList={openList && targetCity}
            poiData={poiData}
            rankSort={rankSort}
            distanceSort={distanceSort}
            itemData={itemData}
            listData={listData}
            setShowBack={setShowBack}
            setItemData={setItemData}
            collectList={collectList}
            cityProvinceInfo={cityProvinceInfo}
            isBatchCollect={isBatchCollect}
            batchCollectIds={batchCollectIds}
            setBatchCollectIds={setBatchCollectIds}
            emitVariableListData={setRealListData}
          />
          <Spin spinning={isLoading} className={styles.loadingCon}/>
          {
            !isLoading && listData?.length === 0 ? <div
              style={{ width: '100%', height: 'calc(100% - 100px)' }}>
              <V2Empty
                type='search'
                centerInBlock
              />
            </div> : <></>
          }
          { // 返回顶部和批量收藏
            showFooterCom ? <Footer
              listData={realListData}
              showBack={showBack}
              isBatchCollect={isBatchCollect}
              backTop={backTop}
              batchCollectIds={batchCollectIds}
              setBatchCollectIds={setBatchCollectIds}
              handleQuitBatch={handleQuitBatch}
            /> : <></>
          }
        </div>
      </div> : <></>
    }

    <Tool
      mapIns={mapIns}
      locationInfo={locationInfo}
      showLeftCon={showLeftCon}
    />

  </>;

};
export default RightCon;
